import * as React from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectErrorDialog, selectErrorWordings } from '../../pages/WorkListPage/slice/selectors';
import { useWorkListStateSlice } from '../../pages/WorkListPage/slice';

export default function ErrorDialog() {
  const { t } = useTranslation();
  const worklistAction = useWorkListStateSlice().actions;
  const dispatch = useDispatch();
  const open = useSelector(selectErrorDialog);
  const wordings = useSelector(selectErrorWordings);

  const handleClose = () => {
    dispatch(worklistAction.updateErrorDialog(false));
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      open={open}
    >
      <Alert severity='warning' onClose={() => {
        handleClose();
      }}>
        {wordings !== '' && t(wordings)}
      </Alert>
    </BootstrapDialog>
  );
}

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));
